/**
 * TXITexType enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file TXITexType.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum TXITexType {
  'DIFFUSE'= 0,
  'BUMPMAP'= 1,
  'NORMALMAP'= 2,
  'ENVMAP'= 3,
  'LIGHTMAP'= 4
};